"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isArguments = exports.defaults = exports.noop = void 0;
const defaults = require("lodash.defaults");
exports.defaults = defaults;
const isArguments = require("lodash.isarguments");
exports.isArguments = isArguments;
function noop() { }
exports.noop = noop;
